import { Individual } from '@aslanpay/portal-common-lib';

/**
 * Whether an authenticated user must be shown the blocking SSO activation step. An authenticated
 * EMPLOYEE still marked INVITED can only be an SSO user who federated in without ever activating —
 * password employees are not authenticated until they are ACTIVE.
 */
export const requiresSsoActivation = (
  individual: Individual | undefined,
  isSsoUser: boolean
): boolean =>
  !!individual && isSsoUser && individual.role === 'EMPLOYEE' && individual.status === 'INVITED';
